import {negativeListService} from "../services";

export default (filters) => {
    return new Promise(async (resolve, reject) => {
        await negativeListService.exportNegativeList(filters)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => reject(err))
    })
}